'use strict';

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!Object.assign) {
    Object.assign = _objectAssign2.default;
} // References:
// https://github.com/sindresorhus/object-assign
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
//# sourceMappingURL=Object.assign.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pixi.js/lib/polyfill/Object.assign.js
// module id = 756
// module chunks = 0